import { Components, Theme } from '@mui/material';
import type { palette as themePalette } from '~/shared/styles/theme/palette';

export const MuiAvatar: Components<Theme>['MuiAvatar'] = {
  styleOverrides: {
    root: ({ theme }) => {
      const palette = theme.palette as unknown as typeof themePalette;
      return {
        backgroundColor: palette.darkNavy,
        color: palette.teal.main,
      };
    },
  },
};
